import { useEffect } from 'react';

import StarRating from './StarRating';

const Review = ({
  pendingChanges = null,
  recipeRating = null,
  id: reviewId,
  ratingDisabled = false,
  onAddReview,
  onReviewChange,
  onUpdateReview,
  starClassNames,
  starSvgClassName,
  uniqueId,
  customOutlineColor,
  ratingSubmittedEvent,
  mealTitle,
}) => {
  const changePending = Boolean(pendingChanges);
  const rating = changePending ? pendingChanges.recipeRating : recipeRating;

  useEffect(() => {
    if (pendingChanges !== null) updateRating();
  }, [pendingChanges]);

  const onChangeRating = rating => {
    onReviewChange({ recipeRating: rating });
  };

  const updateRating = () => {
    const action = reviewId ? onUpdateReview : onAddReview;
    action(pendingChanges);
  };

  return (
    <StarRating
      uniqueId={uniqueId}
      disabled={changePending || ratingDisabled}
      onChange={onChangeRating}
      rating={rating}
      customOutlineColor={customOutlineColor}
      starClassNames={starClassNames}
      starSvgClassName={starSvgClassName}
      ratingSubmittedEvent={ratingSubmittedEvent}
      mealTitle={mealTitle}
    />
  );
};

Review.propTypes = {
  id: PropTypes.string,
  pendingChanges: PropTypes.oneOfType([PropTypes.object, AirbnbPropTypes.explicitNull()]),
  recipeRating: PropTypes.oneOfType([PropTypes.number, AirbnbPropTypes.explicitNull()]),
  onAddReview: PropTypes.func.isRequired,
  onUpdateReview: PropTypes.func.isRequired,
  onReviewChange: PropTypes.func.isRequired,
  uniqueId: PropTypes.string.isRequired,
  ratingDisabled: PropTypes.bool,
  starClassNames: PropTypes.string,
  starSvgClassName: PropTypes.string,
  customOutlineColor: PropTypes.string,
  ratingSubmittedEvent: PropTypes.string,
  mealTitle: PropTypes.string,
};

export default Review;
